

































import Vue from 'vue';
import Component from 'vue-class-component';
import HomeIdeasPlaceInfo from './HomeIdeasPlaceInfo.vue';
import {getTestPlaces, TestPlace} from '@/models/test-place.model';

@Component({
  components: {
    HomeIdeasPlaceInfo
  }
})
export default class HomeIdeasPlaceKnowMore extends Vue {
  places!: TestPlace[];

  created() {
    this.places = getTestPlaces;
  }

  openKnowMore() {
    this.$emit('action');
  }
}
